import React, { type PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import s from './ConstructElements.module.scss'

export function BlockTitle({ children }: PropsWithChildren) {
  return <h4 className={s.blockTitle}>{children}</h4>
}

export function LineSeparator() {
  return <div className={s.separator}></div>
}

export function ActionError({ children }: PropsWithChildren) {
  const { t } = useTranslation()

  return (
    <div className={s.actionError}>
      <h4>{t('error')}</h4>
      <p>{children}</p>
    </div>
  )
}
